/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Status_PendingInputs */

const vi_product_lot_status_pending = /** @type {(inputs: Product_Lot_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ duyệt`)
};

/**

* @param {Product_Lot_Status_PendingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_status_pending = /** @type {((inputs?: Product_Lot_Status_PendingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Status_PendingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_status_pending(inputs)
});